import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconControllerButtonX: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconControllerButtonX"><Path fillRule="evenodd" clipRule="evenodd" d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 10.5859L8.95703 7.54297L7.54297 8.95703L10.5859 12L7.54297 15.043L8.95703 16.457L12 13.4141L15.043 16.457L16.457 15.043L13.4141 12L16.457 8.95703L15.043 7.54297L12 10.5859Z" fill="currentColor"/></CentralIconBase>;
});

export default IconControllerButtonX;
